import { render, staticRenderFns } from "./VSelectSearch.vue?vue&type=template&id=6b7944ac"
import script from "./VSelectSearch.vue?vue&type=script&lang=js"
export * from "./VSelectSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports